import { z } from "zod";

const phoneRegex = /^[+]?[0-9]{10,13}$/;
const vatNumberRegex = /^[A-Z]{2}[0-9A-Z]{9,13}$/;
const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/;
const bicRegex = /^[A-Z]{6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3})?$/;

export const CreateFinancierSchema = z.object({
  name: z.string().min(1, "Name is required"),
  phone: z.string().regex(phoneRegex, "Invalid phone number, e.g. +31612345678"),
  vatNumber: z.string().regex(vatNumberRegex, "Invalid VAT number, e.g. NL123456789B01").optional().or(z.literal("")),
  logo: z.url("Invalid URL").optional().or(z.literal("")),
  address: z.object({
    street: z.string().min(1, "Street is required"),
    houseNumber: z.string().min(1, "House number is required"),
    zipcode: z.string().min(1, "Zip code is required"),
    city: z.string().min(1, "City is required"),
    country: z.string().min(1, "Country is required"),
  }),
  bankAccount: z.object({
    iban: z.string().regex(ibanRegex, "Invalid IBAN"),
    bic: z.string().regex(bicRegex, "Invalid BIC"),
    name: z.string().min(1, "Bank name is required"),
  }),
});

export const CreateFinancierDefaultValues: TCreateFinancierSchema = {
  name: "",
  phone: "",
  vatNumber: "",
  logo: "",
  address: { street: "", houseNumber: "", zipcode: "", city: "", country: "" },
  bankAccount: { iban: "", bic: "", name: "" },
};

export type TCreateFinancierSchema = z.infer<typeof CreateFinancierSchema>;
